import { render } from "./Description.vue?vue&type=template&id=dfa587b4&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"

import "./Description.vue?vue&type=style&index=0&id=dfa587b4&scoped=true&lang=css"

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa587b4"]])

export default __exports__